import DefaultElementNodeType from '../DefaultElementNodeType';
import {APPLICATION_EVENT} from '../../metamodel/Concept';

export default class ApplicationEventNodeType extends DefaultElementNodeType {
	static get typeName() {
		return APPLICATION_EVENT;
	}
}
